var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophyYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 2H13.9999V1C13.9999 0.45 13.5499 0 12.9999 0H4.99994C4.44994 0 3.99994 0.45 3.99994 1V2H1.99994C0.899939 2 -6.10352e-05 2.9 -6.10352e-05 4V5C-6.10352e-05 7.55 1.91994 9.63 4.38994 9.94C5.01994 11.44 6.36994 12.57 7.99994 12.9V16H4.99994C4.44994 16 3.99994 16.45 3.99994 17C3.99994 17.55 4.44994 18 4.99994 18H12.9999C13.5499 18 13.9999 17.55 13.9999 17C13.9999 16.45 13.5499 16 12.9999 16H9.99994V12.9C11.6299 12.57 12.9799 11.44 13.6099 9.94C16.0799 9.63 17.9999 7.55 17.9999 5V4C17.9999 2.9 17.0999 2 15.9999 2ZM1.99994 5V4H3.99994V7.82C2.83994 7.4 1.99994 6.3 1.99994 5ZM15.9999 5C15.9999 6.3 15.1599 7.4 13.9999 7.82V4H15.9999V5Z",
    fill: "#FFA826"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyYellow);
export default __webpack_public_path__ + "static/media/trophy_yellow.0eaa34c1787ff49b37727d49eb43903b.svg";
export { ForwardRef as ReactComponent };